
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/prefit-thankyou",
      function () {
        return require("private-next-pages/prefit-thankyou/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/prefit-thankyou"])
      });
    }
  